'use strict';

/**
 * @classname ChangeDisplayType
 * @classdesc 表示タイプ変更
 */
export default class ChangeDisplayType {
	/**
	 * @constructor
	 * @param {jQuery} $e - .btn--display-type
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._type = $e.attr('data-display-type');
		$e.on('click', () => this.onClick());
		const displayType = localStorage.getItem('_disp_') || null;
		if(displayType === 'list') $('.btn--display-type[data-display-type=list]').click();
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof ChangeDisplayType
	 * @return undefined
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		if(this._$e.hasClass('active')) return;
		$('.btn--display-type').removeClass('active');
		this._$e.addClass('active');
		const $list = $('.list--item-list');
		const $card = $('.list--item-list .card--item');
		if(this._type === 'block'){
			$list.removeClass('list--list');
			$card.removeClass('card--list');
			localStorage.removeItem('_disp_');
		}else if(this._type === 'list'){
			$list.addClass('list--list');
			$card.addClass('card--list');
			localStorage.setItem('_disp_', 'list');
		}
	};
};
